'use strict';

var inputValidation = require('../../../../../../../../_virtual/inputValidation.cjs');

const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
/**
 * Check if value is present
 */ const isValuePresent = (value)=>!!value;
/**
 * Check if email contains an @ character
 */ const isEmailAtValid = (email)=>email.includes("@");
/**
 * Check if email contains a dot character
 */ const isEmailDotValid = (email)=>email.includes(".");
/**
 * Check if email is valid, comparing it against a regex
 */ const isEmailRegexValid = (email)=>emailRegex.test(email);

inputValidation.__exports.isEmailAtValid = isEmailAtValid;
inputValidation.__exports.isEmailDotValid = isEmailDotValid;
inputValidation.__exports.isEmailRegexValid = isEmailRegexValid;
inputValidation.__exports.isValuePresent = isValuePresent;

module.exports = inputValidation.__exports;
//# sourceMappingURL=inputValidation.cjs.map
